/*
  This is an abstraction layer for error tracking, aiming to be able to switch
  supplier under the hood. Most error-tracking services allow reporting of messages
  and errors with some context data.

  Initially we use sentry, which allows logging of messages and errors, but does not
  support performance measurements.

  In development we log to console.
 */

import * as Sentry from '@sentry/browser';

import AppError from './AppError';
import iggloConfig from '../igglo_config';

const consoleTrace = {
  log(message, extra) {
    /* eslint no-console: 0 */
    if (extra) {
      console.log(message, extra);
    } else {
      console.log(message);
    }
  },

  error(err, extra, message) {
    if (message) {
      console.error(message, err);
    } else {
      console.error(err);
    }
    if (extra) {
      console.log(extra);
    }
  },

  warn(...params) {
    console.warn(...params);
  },

  setUser() {}
};

const ravenTrace = {};

const errorCodesNotBeLoggedToSentry = [
  'admin_required',
  'user_already_registered',
  'user_already_validated',
  'user_not_validated',
  'user_unregistered'
];

if (iggloConfig.traceErrors === 'sentry') {
  Sentry.init({
    dsn: 'https://d913d12a6bdf47d89739862ad53469ed@sentry.io/171635',
    // eslint-disable-next-line no-underscore-dangle
    release: global.igglo.__BUILD_VERSION__,
    environment: __ENVIRONMENT__
  });

  ravenTrace.error = function ravenError(err, extra, message) {
    consoleTrace.error(err, extra, message);

    if (err instanceof AppError && errorCodesNotBeLoggedToSentry.includes(err.errorCode)) {
      return;
    }

    if (extra) {
      Sentry.withScope(scope => {
        Object.entries(extra).forEach(([key, value]) => {
          if (typeof value === 'object') {
            scope.setContext(key, JSON.stringify(value, null, 2));
          } else {
            scope.setContext(key, value);
          }
        });

        Sentry.captureException(err);
      });
    } else {
      Sentry.captureException(err);
    }
  };

  ravenTrace.setUser = function ravenSetUser(user) {
    Sentry.setUser(user);
  };

  ravenTrace.log = consoleTrace.log;
  ravenTrace.warn = consoleTrace.warn;
}

export default (iggloConfig.traceErrors === 'sentry') ? ravenTrace : consoleTrace;
